import React from 'react';
import { clsx } from 'clsx';

const badgeVariants = {
  default: "border-transparent bg-gray-900 text-gray-50 hover:bg-gray-900/80",
  secondary: "border-transparent bg-gray-100 text-gray-900 hover:bg-gray-100/80",
  destructive: "border-transparent bg-red-500 text-gray-50 hover:bg-red-500/80",
  outline: "text-gray-950"
};

export function Badge({ className, variant = "default", ...props }) {
  return (
    <div
      className={clsx(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2",
        badgeVariants[variant],
        className
      )}
      {...props}
    />
  );
}